import { StepContainer } from '../components/StepContainer'
import { SingleSelect } from '../components/SingleSelect'
import { useOnboardingStore } from '../store/onboardingStore'
import type { DiagnosisTimeline } from '../types/onboarding'

const options: { value: DiagnosisTimeline; label: string; emoji: string }[] = [
  { value: 'just_now', label: 'Just recently diagnosed', emoji: '🆕' },
  { value: 'under_6mo', label: 'Less than 6 months ago', emoji: '📅' },
  { value: '6mo_to_2yr', label: '6 months to 2 years ago', emoji: '📆' },
  { value: 'over_2yr', label: 'Over 2 years ago', emoji: '🗓️' },
  { value: 'prevention', label: 'Preventive - no diagnosis', emoji: '🛡️' },
]

export function DiagnosisTimelineStep() {
  const { data, goNext } = useOnboardingStore()

  return (
    <StepContainer
      title="When were you diagnosed?"
      subtitle="This helps us understand your journey"
      showContinue={false}
    >
      <SingleSelect
        options={options}
        value={data.diagnosisTimeline}
        onChange={(value) => goNext({ diagnosisTimeline: value })}
      />
    </StepContainer>
  )
}
